import {
  INIT_NOTIFICATION_LIST_REQUEST,
  SET_NOTIFICATION_LIST,
  APPEND_NOTIFICATION_LIST,
  ERROR_NOTIFICATION_LIST,
  DELETE_NOTIFICATION,
  ERROR_NOTIFICATION_REQUEST
} from './action';

const initialState = {
  data: [],
  error: null,
  isLoading: false,
  selectedNotification: null,
  page: 1,
  total: 0,
  totalPage: 1,
  pageSize: 10,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_NOTIFICATION_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case SET_NOTIFICATION_LIST:
      return {
        ...state,
        data: action.payload.data,
        page: action.payload.page,
        total: action.payload.total,
        totalPage: action.payload.totalPage,
        pageSize: action.payload.pageSize,
        isLoading: false,
        error: null,
      };

    case APPEND_NOTIFICATION_LIST:
      return {
        ...state,
        data: [...state.data, ...action.payload.data],
        page: action.payload.page,
        total: action.payload.total,
        totalPage: action.payload.totalPage,
        pageSize: action.payload.pageSize,
        isLoading: false,
        error: null,
      };

    case DELETE_NOTIFICATION:
      return {
        ...state,
        data: state.data.filter(notification => notification.id !== action.payload),
        isLoading: false,
        error: null,
      };

    case ERROR_NOTIFICATION_LIST:
      return {
        ...state,
        data: [],
        isLoading: false,
        error: action.payload,
      };


    case ERROR_NOTIFICATION_REQUEST:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default notificationReducer;
